import React, { useState } from 'react'
import styled from 'styled-components'
import { useUser } from 'apis/hooks'
import { TriggerExceptTarget } from 'components/misc/trigger'
import { Row } from 'components/common/layout'
import { FiSearch, FiUser } from 'react-icons/fi'
import { MyLink } from 'components/common/link'
import { useStores } from 'stores/globals'
import { MyDropdownMenu } from 'components/misc/header/header-dropdown-menu'
import { analytics } from 'infra/analytics'
import { DASHBOARD_DEFAULT_URL } from 'infra/constants'
import { useIsLoggedInStartup } from 'utils/hooks'
import { StartupSearchModal } from 'components/misc/startup-search-modal'
import { theme } from 'infra/theme'
import { AlertBadge } from 'components/common/badge'
import { useRouter } from 'next/router'
import { ChatIcon } from 'components/common/icon'
import { BtnSize, BtnType, Button } from 'components/common/button'

const DesktopHeaderProfile: React.FC = () => {
  const { loginStore } = useStores()
  const { data: user } = useUser({ ssr: false })
  const [openDropdown, setOpenDropdown] = useState(false)
  const [openSearchModal, setOpenSearchModal] = useState(false)
  const isLoggedInStartup = useIsLoggedInStartup()
  const router = useRouter()
  return (
    <Row style={{ gap: 12 }}>
      <HoverEffect
        onClick={() => {
          setOpenSearchModal(true)
          analytics.track('click_mi_search_btn')
        }}
      >
        <FiSearch
          size={24}
          color={user ? theme.color.black2 : theme.color.primary}
        />
      </HoverEffect>
      {user && (
        <MyLink href='/chat-rooms'>
          <HoverEffect>
            <IconWrapper isSelected={router.pathname === '/chat-rooms'}>
              {user.newMessageCount !== 0 && (
                <AlertBadge size={20} top={8} right={-6}>
                  {user.newMessageCount}
                </AlertBadge>
              )}
              <ChatIcon size={26} strokeWidth={0.2} />
            </IconWrapper>
          </HoverEffect>
        </MyLink>
      )}
      {user ? (
        <TriggerExceptTarget onTrigger={() => setOpenDropdown(false)}>
          <HoverEffect onClick={() => setOpenDropdown(!openDropdown)}>
            <IconWrapper
              isSelected={
                router.pathname.includes('my-profile') ||
                router.pathname.includes('my-activities') ||
                router.pathname.includes('interested-in-me') ||
                router.pathname.includes('my-page')
              }
            >
              <FiUser size={24} color={theme.color.black2} />
              {openDropdown && <MyDropdownMenu />}
            </IconWrapper>
          </HoverEffect>
        </TriggerExceptTarget>
      ) : (
        <Row style={{ gap: 8 }}>
          <Button
            onClick={() => {
              loginStore.setIsModalOpen(true)
              analytics.track('click_jsu_click_headerSignupCta')
            }}
            size={BtnSize.MEDIUM}
            variant={BtnType.LINEAR}
          >
            회원가입 · 로그인
          </Button>
          <MyLink href={isLoggedInStartup ? DASHBOARD_DEFAULT_URL : '/biz'}>
            <Button
              variant={BtnType.OUTLINE}
              size={BtnSize.MEDIUM}
              style={{ width: 'max-content' }}
            >
              기업 서비스
            </Button>
          </MyLink>
        </Row>
      )}
      {openSearchModal && (
        <StartupSearchModal onClose={() => setOpenSearchModal(false)} />
      )}
    </Row>
  )
}

const HoverEffect = styled(Row)`
  width: 38px;
  height: 38px;
  justify-content: center;
  border-radius: 100px;
  :hover {
    background-color: ${(p) => p.theme.color.background};
  }
  cursor: pointer;
`

const IconWrapper = styled(Row)<{ isSelected: boolean }>`
  position: relative;
  height: 56px;
  ${(p) =>
    p.isSelected &&
    `border-bottom: 4px solid ${p.theme.color.primary}; margin-top: 4px;`};
`

export default DesktopHeaderProfile
